import { ReconfigureAgentPanelWebComponent } from './component/ReconfigureAgentPanelWebComponent';
import { WEB_COMPONENT_RECONFIGURE_AGENT_PANEL } from '../../../webcomponents.constants';

export { ReconfigureAgentPanelWebComponent };

window.customElements.define(WEB_COMPONENT_RECONFIGURE_AGENT_PANEL, ReconfigureAgentPanelWebComponent);
